import {
  UPDATE_DEAL,
  CLEAR_DEAL_SUMMARY,
  LOAD_DEAL_SUMMARY,
  RECEIVE_DEAL_SUMMARY,
  FAIL_DEAL_SUMMARY
} from 'redux/actions/types';
import { IDealSummary } from 'hooks/useDealSummary/interface';
import isEqual from 'react-fast-compare';

type LoadStatus = 'idle' | 'loading' | 'ready' | 'error';

interface DealSummaryState {
  deal: IDealSummary;
  dealId: string | null;
  loadStatus: LoadStatus;
}

const initialState: DealSummaryState = {
  deal: {} as IDealSummary,
  dealId: null,
  loadStatus: 'idle'
};

interface UpdateDealSummary {
  type: typeof UPDATE_DEAL;
  payload: IDealSummary;
}

interface ClearDealSummary {
  type: typeof CLEAR_DEAL_SUMMARY;
  payload: IDealSummary;
}

interface LoadDealSummary {
  type: typeof LOAD_DEAL_SUMMARY | typeof FAIL_DEAL_SUMMARY;
  dealId: string;
}

interface ReceiveDealSummary {
  type: typeof RECEIVE_DEAL_SUMMARY;
  dealId: string;
  payload: IDealSummary;
}

type formAction =
  | UpdateDealSummary
  | ClearDealSummary
  | LoadDealSummary
  | ReceiveDealSummary;

export default (state = initialState, action: formAction): DealSummaryState => {
  switch (action.type) {
    case UPDATE_DEAL:
      return { ...state, deal: action.payload };
    case CLEAR_DEAL_SUMMARY:
      // Keep the subscription identity so its next snapshot can repopulate
      // the cleared summary without opening another listener.
      return { ...initialState, dealId: state.dealId };
    case LOAD_DEAL_SUMMARY:
      // Several components share this summary. A second subscription must
      // not clear data or restart loading for a deal that is already ready.
      if (state.dealId === action.dealId) return state;
      return { ...initialState, dealId: action.dealId, loadStatus: 'loading' };
    case RECEIVE_DEAL_SUMMARY:
      if (state.dealId !== action.dealId) return state;
      if (state.loadStatus === 'ready' && isEqual(state.deal, action.payload))
        return state;
      return { ...state, deal: action.payload, loadStatus: 'ready' };
    case FAIL_DEAL_SUMMARY:
      if (state.dealId !== action.dealId || state.loadStatus === 'error')
        return state;
      return { ...state, loadStatus: 'error' };
    default:
      return state;
  }
};
